export function isImage(contentType: string): boolean {
  return contentType.startsWith('image/');
}

export function isPdf(contentType: string): boolean {
  return contentType === 'application/pdf';
}

export function isVideo(contentType: string): boolean {
  return contentType.startsWith('video/');
}

export function isAudio(contentType: string): boolean {
  return contentType.startsWith('audio/');
}

export function isPreviewable(contentType: string): boolean {
  return isImage(contentType) || isPdf(contentType) || isVideo(contentType) || isAudio(contentType);
}

export type FileTypeCategory = 'image' | 'pdf' | 'video' | 'audio' | 'archive' | 'document' | 'other';

export function getFileTypeCategory(contentType: string): FileTypeCategory {
  if (isImage(contentType)) return 'image';
  if (isPdf(contentType)) return 'pdf';
  if (isVideo(contentType)) return 'video';
  if (isAudio(contentType)) return 'audio';
  if (
    contentType.includes('zip') ||
    contentType.includes('rar') ||
    contentType.includes('7z') ||
    contentType.includes('tar') ||
    contentType.includes('gzip')
  )
    return 'archive';
  if (
    contentType.includes('document') ||
    contentType.includes('spreadsheet') ||
    contentType.includes('presentation') ||
    contentType.includes('msword') ||
    contentType.includes('ms-excel') ||
    contentType.includes('ms-powerpoint') ||
    contentType === 'text/plain' ||
    contentType === 'text/csv'
  )
    return 'document';
  return 'other';
}
